angular.module("app").controller("ChangePassModalController", [
    '$uibModal',
    '$scope',
    function ($modal, $scope) {
        $scope.open = function () {
            $modal.open({
                windowTemplateUrl: 'views/templates/modals/windowChangePassword.html',
                templateUrl: 'views/templates/modals/small-popup-template.html',
                controller: "ModalInstanceController",
                backdrop: 'static',
                keyboard: false
            });
        };
    }
]);